import React from "react";

import print1 from "../../../../assets/print1.png";
import print2 from "../../../../assets/print2.png";
import print3 from "../../../../assets/print3.png";
import print4 from "../../../../assets/print4.png";
import print5 from "../../../../assets/print5.png";

import pdf1 from "../../../../assets/New Stickers 100mm diameter 1.pdf";
import pdf2 from "../../../../assets/New sticker 100 x 100mm 1 (1).pdf";
import pdf3 from "../../../../assets/New sticker 100 x 100mm 1.pdf";
import pdf4 from "../../../../assets/Print ready A5 flyers 1.pdf";
import pdf5 from "../../../../assets/New business cards 1.pdf";

import downloadsymbol from "../../../../assets/download-symbol.png";
import pdfIcon from "../../../../assets/pdf-icon.png";
import GlowButton from "../../GlowButton";

// DATA
const printItems = [
  {
    id: 1,
    img: print1,
    pdf: pdf1,
    title: "new stickers 100mm diameter.pdf",
    desc: "high-quality printable sticker design ready for download and use.",
  },
  {
    id: 2,
    img: print2,
    pdf: pdf2,
    title: "new sticker 100 x 100mm <br>(1).pdf",
    desc: "high-quality printable sticker design ready for download and use.",
  },
  {
    id: 3,
    img: print3,
    pdf: pdf3,
    title: "new sticker 100 x <br> 100mm.pdf",
    desc: "high-quality printable sticker design ready for download and use.",
  },
  {
    id: 4,
    img: print4,
    pdf: pdf4,
    title: "print ready a5 <br> flyers.pdf",
    desc: "high-quality printable sticker design ready for download and use.",
  },
  {
    id: 5,
    img: print5,
    pdf: pdf5,
    title: "new business <br> cards.pdf",
    desc: "high-quality printable sticker design ready for download and use.",
  },
];

const PrintMaterials = () => {
  return (
    <section className="w-full bg-[#f9fafb] py-16 px-6 font-[Lexend]">
      <div className="max-w-[1280px] mx-auto">

        {/* FULLY RESPONSIVE GRID */}
       <div
  className="
    grid 
    grid-cols-1        /* MOBILE → ALWAYS 1 per row */
    xs:grid-cols-1     /* Extra safeguard */
    sm:grid-cols-1     /* Small screens still 1 */
    md:grid-cols-2     /* Tablet – 2 per row */
    lg-xl:grid-cols-2     /* Laptop – 4 per row */
    xl-2xl:grid-cols-4
    gap-10 
    place-items-center
  "
>

          {printItems.map((item) => (
            <PrintCard key={item.id} {...item} />
          ))}
        </div>

      </div>
    </section>
  );
};

function PrintCard({ id, img, pdf, title, desc }) {
  return (
    <div
      className="
        bg-white
        rounded-2xl
        shadow-[0_4px_20px_rgba(0,0,0,0.03)]
        hover:shadow-[0_12px_28px_rgba(0,0,0,0.12)]
        transition
        w-full
        sm:max-w-[400px]
        overflow-hidden
        py-4
      "
    >

      {/* IMAGE */}
      <div className="w-full flex justify-center p-7">
        <a href={pdf} target="_blank" rel="noopener noreferrer">

          {/* Dynamic heights */}
          <img
            src={img}
            alt={title}
            className={`
              cursor-pointer 
              hover:scale-105 
              transition-transform 
              duration-500 
              rounded-t-xl
              ${
                id === 5
                  ? "w-[250px] h-[161px]"
                  : id === 4
                  ? "w-[250px] h-[290px]"
                  : "w-[250px] h-[284px]"
              }
            `}
          />
        </a>
      </div>

      {/* CONTENT */}
      <div className="px-6 text-center">

        {/* PDF Title */}
        <a
          href={pdf}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-[#111] hover:underline justify-center mb-2"
        >
          <img src={pdfIcon} alt="pdf icon" className="w-5 h-5" />

          <span
            className="font-semibold text-[15px] leading-snug"
            dangerouslySetInnerHTML={{ __html: title }}
          ></span>
        </a>

        {/* Description */}
        <p className="text-[#6b7280] text-sm leading-relaxed mb-6">
          {desc}
        </p>

        {/* DOWNLOAD BUTTON — ALWAYS CENTERED */}
        <div className="w-full flex justify-center">
          <a href={pdf} download>
            {/* <button
              type="button"
              className="
                flex items-center
                px-4 py-2
                rounded-[20px]
                bg-purple-50 
                border border-gray-300
                hover:border-gray-400
                hover:bg-purple-100
                transition
              "
            >
              <span className="font-normal text-[12.59px] lowercase mr-2">
                download
              </span>
              <img src={downloadsymbol} alt="download icon" />
            </button> */}
             <span className="mt-0 flex justify-center sm:mr-[30px] ml-0  items-start">
            <GlowButton btnValue="download" btn1="3"></GlowButton>
          </span>
          </a>
        </div>

      </div>
    </div>
  );
}

export default PrintMaterials;
